import { useCallback, useEffect, useState } from "react"
import { whatsappMessageFormat, whatsaappMessageTypes } from "utils/shareToWhatsApp"
import { Modal, ModalOverlay, ModalContent, ModalBody, Flex, Button, Heading, Select, ModalHeader, Textarea, ModalFooter } from "@chakra-ui/react"
import { shareToWhatsApp } from "utils/shareToWhatsApp"

const planUserTypes = {
    tenant: "Tenant",
    buyer: "Buyer",
    agent: "Agent",
    pg_owner: "PG Owner",
    landlord: "Landlord",
    seller: "Seller",
    co_living: "Co Living",
    pg_seeker: "PG Seeker"
}

const planTypes = {
    pro: "Pro",
    pro_plus: "Pro Plus",
}

const ShareToWhatsapp = ({ isOpen, onClose, userData, planUserType, planType , defaultMessageType,slug }) => {
    const {first_name, phone} =userData || {}
    const [messageType, setMessageType] = useState(defaultMessageType)
    const [whatsappMessage, setWhatsappMessage] = useState("")

    const getCurrentMessage = useCallback(
        (msgType) => {
            if (!msgType) return ""

            const template = whatsappMessageFormat[msgType]
            if (!template) return ""

            const link = `${process.env.REACT_APP_HEXAHOME_BASE_URL}/plans/${planUserType}/?tab=${planType}`

            const replacements = {
                "{{user}}": first_name ?? "",
                "{{plan_name}}": `${planUserTypes[planUserType] ?? ""} ${planTypes[planType] ?? ""} Plan`,
                "{{link}}": link,
                "{{slug}}": slug,
                "{{plan_type}}": planUserType ?? "",
            }

            return Object.entries(replacements).reduce(
                (msg, [placeholder, value]) => msg.replace(placeholder, value),
                template
            )
        },
        [first_name, planUserType, planType,slug]
    )

    const handleShare = useCallback(() => {
        shareToWhatsApp(whatsappMessage, phone);
        onClose();
    }, [whatsappMessage, phone])

    useEffect(() => {
        if (messageType) {
            setWhatsappMessage(getCurrentMessage(messageType))
        }
    }, [messageType, getCurrentMessage])

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="2xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Heading size="md" color="gray.800">
                        Share To Whatsapp
                    </Heading>
                    <Button
                        variant="outline"
                        borderRadius="full"
                        position="absolute"
                        top={2}
                        right={4}
                        zIndex={1}
                        size="sm"
                        onClick={onClose}
                    >
                        x
                    </Button>
                </ModalHeader>
                <ModalBody position="relative">
                    <Flex direction="column" gap={4}>
                        <Select
                            value={messageType}
                            onChange={(e) => setMessageType(e.target.value)}
                            size="md"
                            placeholder="Select Message Type"
                        >
                            {whatsaappMessageTypes.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </Select>
                        <Textarea value={whatsappMessage} onChange={(e) => setWhatsappMessage(e.target.value)} minHeight={250} />
                    </Flex>
                </ModalBody>
                <ModalFooter>
                    <Button
                        background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
                        color="#ffffff"
                        mr={3}
                        onClick={handleShare}
                        disabled={whatsappMessage === ''}
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ShareToWhatsapp
